import { render, staticRenderFns } from "./SelectClientDialog.vue?vue&type=template&id=2336f79b&"
import script from "./SelectClientDialog.vue?vue&type=script&lang=js&"
export * from "./SelectClientDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectClientDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports